import * as React from 'react';
import { memo } from "react";
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import ColorPicker from "../../components/colorPicker";
import ColorSwatch from "../../components/colorSwatch";
import { isFunction } from "../../helpers/utils";
import { presetTextColors } from "../colors";
import { clsx } from 'clsx';

interface Props {
	color?: string,
	onChange?: (color?: string) => any
	buttonCssClass?: string,
	disabled?: boolean
}

function PopoverTextColor({ color = '', onChange = null, buttonCssClass = '', disabled = false, ...otherProps}: Props) {

	function update(value: string) {
		if (isFunction(onChange)) {
			onChange(value);
		}
	}

	return (<>
		<Popover className="relative inline-block">
			<PopoverButton
				color={color}
				className={clsx((color) ? '' : 'bg-no-color', buttonCssClass)}
				selected={color !== null && color !== '' && color !== undefined}
				as={ColorSwatch}
				disabled={disabled}
			>Txt</PopoverButton>

			<PopoverPanel anchor="bottom start" className="box p-5 flex shadow-lg [--anchor-gap:4px]">
				<div>
					<ColorPicker
						color={color}
						onChange={(color: string) => update(color)}
						preset={presetTextColors}
					/>
				</div>
			</PopoverPanel>
		</Popover>
	</>);
}

export default memo(PopoverTextColor);
